module.exports = __webpack_public_path__ + "img/timer.2f52a0c5.svg";